import {
  BasketColumn,
  BasketColumnKeys,
} from 'graphql-api/baskets-api-interfaces';

export const mapValueColumnByBasketStatus =
  (isBasketPlaced: boolean) =>
  (columns: BasketColumn[]): BasketColumn[] => {
    return columns.map((column) => {
      if (isBasketPlaced && column.key === BasketColumnKeys.Value) {
        return { ...column, key: BasketColumnKeys.ValueNet };
      }

      return column;
    });
  };
